<template>
  <vue-slider
    ref="slider"
    v-model="currentValue"
    v-bind="sliderOptions"
    :data="timeRange"
    :formatter="formatTime"
    :disabled="disabled"
  >
  </vue-slider>
</template>
<script>
import moment from 'moment';
import VueSlider from 'vue-slider-component';

const getMinutes = time => parseInt(time.split(':')[1], 10);
const getHour = time => parseInt(time.split(':')[0], 10);

export default {
  components: { VueSlider },

  mounted() {
    this.currentValue = this.value;
    setTimeout(() => {
      this.$refs.slider.refresh();
    }, 1000);
  },

  data: () => {
    const sliderOptions = {
      enableCross: false,
      minRange: 1,
      processDragable: true,
      tooltipDir: ['bottom', 'bottom'],
      dotSize: 22,
      sliderStyle: {
        backgroundColor: '#72BF21',
      },
      processStyle: {
        backgroundColor: '#72BF21',
      },
      tooltipStyle: {
        background: 'none',
        border: 'none',
        color: '#11141F',
        fontSize: '10px',
        lineHeight: '13px',
        '&:before': {
          display: 'none',
        },
      },
    };

    return {
      currentValue: null,
      sliderOptions,
    };
  },

  props: {
    value: Array,
    start: {
      type: String,
      default: '07:30',
    },
    end: {
      type: String,
      default: '22:30',
    },
    disabled: Boolean,
  },

  computed: {
    timeRange() {
      const hours = [];
      moment.locale('en');

      let hour = getHour(this.start);
      const endHour = getHour(this.end);
      const endMinutes = getMinutes(this.end);

      if (getMinutes(this.start) === 30) {
        hours.push(
          moment({
            hour,
            minute: 30,
          }).format('HH:mm'),
        );

        hour += 1;
      }

      for (; hour <= endHour; hour += 1) {
        hours.push(moment({ hour }).format('HH:mm'));

        if (hour !== endHour) {
          hours.push(
            moment({
              hour,
              minute: 30,
            }).format('HH:mm'),
          );
        }
      }

      if (endMinutes === 30) {
        hour -= 1;
        hours.push(
          moment({
            hour,
            minute: 30,
          }).format('HH:mm'),
        );
      }

      return hours;
    },
  },

  methods: {
    formatTime(timeString) {
      const hour = getHour(timeString);
      const minute = getMinutes(timeString);

      return moment({ hour, minute }).format('h:mma');
    },
  },

  watch: {
    currentValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Booking/SlideTimePicker.vue